import React from "react";

const LocationIcon = () => {
	return (
		<svg
			width='23'
			height='23'
			viewBox='0 0 23 23'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_41_2)'>
				<path
					d='M15.2567 14.5955L17.5854 10.5417C18.2112 9.47353 18.5411 8.25787 18.5411 7.01985C18.5411 5.78183 18.2112 4.56617 17.5854 3.49798C16.9665 2.42957 16.0777 1.54261 15.0079 0.926018C13.9382 0.309426 12.7251 -0.0151367 11.4904 -0.0151367C10.2557 -0.0151367 9.04267 0.309426 7.97292 0.926018C6.90318 1.54261 6.01431 2.42957 5.39542 3.49798C4.7696 4.56617 4.43971 5.78183 4.43971 7.01985C4.43971 8.25787 4.7696 9.47353 5.39542 10.5417L7.72417 14.5763C3.83333 15.0555 0 16.2917 0 18.6876C0 21.6488 5.96083 23.0001 11.5 23.0001C17.0392 23.0001 23 21.6488 23 18.6876C23 16.2917 19.1667 15.0555 15.2567 14.5955ZM7.06292 4.47548C7.38763 3.87323 7.82982 3.34222 8.36333 2.91384C8.89684 2.48547 9.51083 2.16842 10.169 1.98146C10.8272 1.79449 11.5161 1.74141 12.1952 1.82535C12.8742 1.90928 13.5295 2.12853 14.1224 2.47013C14.7152 2.81173 15.2335 3.26874 15.6466 3.81414C16.0598 4.35953 16.3593 4.98223 16.5276 5.64542C16.6959 6.3086 16.7295 6.9988 16.6265 7.6752C16.5234 8.35159 16.2857 9.00045 15.9275 9.58339L11.5 17.2501L7.0725 9.58339C6.62085 8.80838 6.38208 7.92774 6.3804 7.03073C6.37871 6.13371 6.61417 5.25218 7.06292 4.47548ZM11.5 21.0834C5.175 21.0834 1.91667 19.4063 1.91667 18.6876C1.91667 18.1796 3.97708 16.8188 8.7975 16.4067L10.0912 18.6396C10.2345 18.8863 10.4401 19.091 10.6873 19.2333C10.9345 19.3756 11.2147 19.4505 11.5 19.4505C11.7853 19.4505 12.0655 19.3756 12.3127 19.2333C12.5599 19.091 12.7655 18.8863 12.9087 18.6396L14.2025 16.4067C19.0229 16.8188 21.0833 18.2084 21.0833 18.6876C21.0833 19.4063 17.825 21.0834 11.5 21.0834Z'
					fill='black'
				/>
				<path
					d='M11.5 8.62508C12.5585 8.62508 13.4166 7.76696 13.4166 6.70841C13.4166 5.64987 12.5585 4.79175 11.5 4.79175C10.4414 4.79175 9.58331 5.64987 9.58331 6.70841C9.58331 7.76696 10.4414 8.62508 11.5 8.62508Z'
					fill='black'
				/>
			</g>
			<defs>
				<clipPath id='clip0_41_2'>
					<rect width='23' height='23' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default LocationIcon;
